'use strict';

var typeaheadCustomTextInput = require('./index-chunk.js');
require('@shared-ui/localization-context');
require('react');
require('@egds/react-core/field');
require('@egds/react-core/icons');
require('@egds/react-core/utils');
require('../styles/egds-search-experience-typeahead-custom-text-input.css');
exports.TypeaheadCustomTextInput = typeaheadCustomTextInput.TypeaheadCustomTextInput;
//# sourceMappingURL=index.js.map
